<template>
  <el-row :gutter="24">
    <el-col :span="12">
      <h2>Установить статус проверки документа</h2>
      <el-radio-group v-model="approveStatus">
        <el-radio-button :label="1">Полность одобрить</el-radio-button>
        <el-radio-button :label="2">Отказать с комментарием</el-radio-button>
      </el-radio-group>

      <p v-if="approveStatus == 2">
        <el-input
          v-model="NotApproveReason"
          type="textarea"
          :rows="3"
          placeholder="Введите причину отказа"
        />
      </p>
      <div v-if="approveStatus == 1" style="padding: 10px">
        <b>
          Файлы после утверждения изменить будет нельзя. И они будут считаться
          проверенными сервисом
        </b>
      </div>
      <el-button v-if="approveStatus != ''" type="primary" @click="setApprove">
        Выполнить
      </el-button>
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: 'ApproveFile',
  data() {
    return {
      approveStatus: '',
      NotApproveReason: '',
    }
  },

  methods: {
    setApprove() {
      this.$emit('approved', {
        status: this.approveStatus,
        comment: this.NotApproveReason,
      })
    },
  },
}
</script>

<style scoped></style>
